import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const UserCarsTable = ({
  data,
  meta,
  language,
  onEdit,
  onDelete,
  onView,
  onPageChange,
}) => {
  if (!meta) return null;

  const {
    current_page,
    last_page,
    from,
    to,
    total,
    prev_page_url,
    next_page_url,
  } = meta;

  const pages = Array.from({ length: last_page }, (_, i) => i + 1);

  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[900px]">
        <thead className="bg-muted border-b">
          <tr>
            <th className="px-4 py-3 text-center">السيارة</th>
            <th className="px-4 py-3 text-center">الوصف</th>
            <th className="px-4 py-3 text-center"></th>
          </tr>
        </thead>

        <tbody className="divide-y">
          {data?.map((item) => (
            <tr key={item.id} className="hover:bg-muted/50">
              <td className="px-4 py-3 text-center">{item.translations?.ar}</td>

              {/* الوصف مع تقصير + Tooltip */}
              <td className="px-4 py-3 text-center">
                <div className="relative group cursor-pointer inline-block max-w-xs">
                  <span>
                    {item.description?.length > 100
                      ? item.description.slice(0, 100) + "..."
                      : item.description}
                  </span>

                  {item.description?.length > 100 && (
                    <div className="absolute z-10 hidden group-hover:block bg-black text-white text-xs rounded p-2 w-64 top-full mt-1 text-right shadow-lg">
                      {item.description}
                    </div>
                  )}
                </div>
              </td>

              <td className="px-4 py-3">
                <div className="flex justify-center gap-2">
                  <button onClick={() => onView(item)} className="text-primary">
                    <Icon name="Eye" size={16} />
                  </button>

                  <button onClick={() => onEdit(item)} className="text-warning">
                    <Icon name="Edit2" size={16} />
                  </button> 

                  <button onClick={() => onDelete(item)} className="text-error">
                    <Icon name="Trash2" size={16} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center p-4 bg-muted/30 gap-3">
        <span className="text-sm text-text-secondary">
          {from}-{to} من {total}
        </span>

        <div className="flex gap-1 flex-wrap">
          <Button
            size="sm"
            variant="outline"
            disabled={!prev_page_url}
            onClick={() => onPageChange(current_page - 1)}
          >
            السابق
          </Button>

          {pages.map((page) => (
            <Button
              key={page}
              size="sm"
              variant={page === current_page ? "default" : "outline"}
              onClick={() => onPageChange(page)}
            >
              {page}
            </Button>
          ))}

          <Button
            size="sm"
            variant="outline"
            disabled={!next_page_url}
            onClick={() => onPageChange(current_page + 1)}
          >
            التالي
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserCarsTable;
